/**
 *
 */
import React, { createContext, useCallback, useContext, useState } from 'react';
import { nanoid } from 'nanoid';

export interface IDialog {
    content: any
    onClose?: () => void
}

export interface IDialogWithId extends IDialog {
    id: string
}

export interface IDialogs {
    dialogs: Array<IDialogWithId>
    openDialog: (dialog: IDialog) => void
    closeDialog: (id: IDialogWithId['id']) => void
}


export const DialogsContext = createContext<IDialogs>({
    dialogs: [],
    openDialog: (dialog: IDialog) => { },
    closeDialog: (id: IDialogWithId['id']) => { }
});

export const useDialogs = () => {
    return useContext(DialogsContext);
};

interface IDialogsProps {
    children: any
}

function Dialogs({ children }: IDialogsProps) {
    const [dialogs, setDialogs] = useState<Array<IDialogWithId>>([
        // {
        //     id: nanoid(),
        //     content: "AHOJ"
        // }
    ]);

    const openDialog = useCallback(
        (dialog: IDialog) => {
            setDialogs([
                ...dialogs,
                {
                    ...dialog,
                    id: nanoid()
                }
            ]);
        },
        [dialogs]
    );

    const closeDialog = useCallback(
        (id: IDialogWithId['id']) => {
            setDialogs(
                dialogs.filter(dialog => dialog.id !== id)
            );
        },
        [dialogs]
    );

    return (
        <DialogsContext.Provider value={{ dialogs, openDialog, closeDialog }}>
            {children}
        </DialogsContext.Provider>
    );
}

export default Dialogs;
